<template>
  <li>
    <slot />
  </li>
</template>

<script setup lang="ts"></script>
